import * as React from "react";
import { Popover, OverlayTrigger, Button, Form } from 'react-bootstrap';
import { KeyValue } from '../BaseClasses';
import { wrapCheckbox } from "../FormChangeWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IProps {
    title: string;
    precheckedAll: boolean;
    data: KeyValue<string, string>[];
    selectedItems?: string[];
    width?: string;
    size?: "sm" | "lg";
    placeholder?: string;
    onChange: (keys: string[]) => void
}
interface IState {
    selectedValues: string[],
    allIsChecked: boolean;
}

export class MultiSelect extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            selectedValues: this.props.selectedItems || [],
            allIsChecked: this.props.precheckedAll
        }

        this.changeCheckbox = this.changeCheckbox.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps: IProps) {
        this.setState({
            selectedValues: newProps.selectedItems || []
        })
    }

    // componentDidUpdate(prevProps: IProps, prevState: IState, snapshot: any) {
    //     this.setState({
    //         selectedValues: this.props.selectedItems || []
    //     })
    // }


    private changeCheckbox(name: string, value: string, checked: boolean) {
        if (value == "-1") {
            this.setState({
                allIsChecked: checked,
                selectedValues: checked ? this.props.data.map(item => item.Key) : []
            }, () => {
                this.props.onChange(this.state.selectedValues);
            })
        }
        else {
            const newSelectedValues = this.state.selectedValues.filter(w => w != value);
            if (checked) {
                newSelectedValues.push(value);
            }

            this.setState({
                allIsChecked: false,
                selectedValues: newSelectedValues
            }, () => {
                this.props.onChange(this.state.selectedValues);
            })
        }
    }



    render() {

        const popover = (
            <Popover id="popover-basic" style={{ zIndex: 1029, width: (this.props.width || 300) + "px" }}>
                <Popover.Title as="h3">{this.props.title}</Popover.Title>
                <Popover.Content>
                    <Form>
                        <Form.Group controlId="totalCheckbox" style={{ margin: 0 }}>
                            <Form.Check
                                id="totalCheckbox"
                                key={-1}
                                type="checkbox"
                                label='Все'
                                value={-1}
                                onChange={wrapCheckbox(this.changeCheckbox)}
                                checked={this.state.allIsChecked}
                            />
                        </Form.Group>
                        {(this.props.data || []).map(item =>
                            <Form.Group controlId={"item_checkbox_" + item.Key} style={{ margin: 0 }} key={item.Key}>
                                <Form.Check
                                    id={"item_checkbox_" + item.Key}
                                    type="checkbox"
                                    label={item.Value}
                                    value={item.Key}
                                    onChange={wrapCheckbox(this.changeCheckbox)}
                                    checked={this.state.allIsChecked || this.state.selectedValues.indexOf(item.Key) > -1}

                                />
                            </Form.Group>)}
                    </Form>
                </Popover.Content>
            </Popover>
        );

        const selectListText = this.state.selectedValues.length <= 0 ? this.props.placeholder || 'Не выбрано' :
            this.props.data.filter(w => this.state.selectedValues.indexOf(w.Key) > -1)
                .sort((a, b) => a.Value > b.Value ? 1 : -1)
                .map(w => w.Value)
                .join(', ');

        return <OverlayTrigger trigger="click" placement="bottom" overlay={popover} rootClose={true} rootCloseEvent="click" >
            <div
                style={{ minWidth: "200px", padding: "0", width: (this.props.width || 300) + "px", cursor: "pointer" }}
                className={`form-control ${this.props.size == "sm" ? "form-control-sm" : ""}`}
                title={selectListText}>
                <div style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    float: "left",
                    width: "inherit",
                    marginLeft: "-20px",
                    height: "100%",
                    padding: "0.375rem 0.75rem",
                    paddingLeft: "25px"
                }}>
                    {selectListText}
                </div>
                <div style={{ float: "left", width: "15px", height: "100%", padding: this.props.size == "sm" ? "0.10rem 0px" : "0.25rem 0px" }}>
                    <FontAwesomeIcon icon="sort-down" />
                </div>

            </div>
        </OverlayTrigger >
    }
}